<template>
    <div v-if="projID && proj" class="animated fadeIn">

        <!-- 專案資訊 -->
        <div class="container-fluid">

            <b-row>
                <b-col md="12">
                    <EditProjectDevices :projectID="proj.id"></EditProjectDevices>
                </b-col>
            </b-row>

            <div class="proj-toolbox-area">
                <!-- 場域架構圖 -->
                <ProjectMap :showControlTips="false" :editMode="true"></ProjectMap>
            </div>

        </div>

    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import EditProjectDevices from '@/views/device/Edit_Project_Devices'
    import ProjectMap from '@/views/project/ProjectMap'

    export default {
        name: 'deviceManagement',
        components: {
            EditProjectDevices,
            ProjectMap,
        },
        data: function () {
            return {
                uploading: false,
            }
        },
        // 在 router 改變、vue 頁面更新後處理：頁面網址數值變更自動執行
        beforeRouteUpdate(to, from, next) {
            // console.log(to.params.projectID + ' ?' + Math.random());
            this.getProject(to, from, next);
        },
        mounted() {
            this.getProject();
        },
        computed: {
            ...mapState({
                'user_admin': state => state.user.is_admin,
                'projects': state => state.project.projects,
                'project_detail': state => state.project.project_detail,
            }),

            proj() {
                return this.project_detail
            },

            projID() {
                return this.$route.params.projectID;
            },

            checkLongtitude ()
            {
                return this.$tools.input.checkFloat( this.projInfo.longitude );
            },
            checkLatitude ()
            {
                return this.$tools.input.checkFloat( this.projInfo.latitude );
            },
            checkZoom ()
            {
                return this.$tools.input.checkFloat( this.projInfo.zoom );
            },

            checkDisabled() {
                if ( this.checkLongtitude == false ) return true
                if ( this.checkLatitude == false )   return true
                if ( this.checkZoom == false )       return true

                if (this.$tools.input.checkRequired(this.projInfo.name) == false) return true;

                if (this.projInfo.cropperiod_max_limit == undefined || this.projInfo.cropperiod_max_limit == '') return true;
                if (this.projInfo.start_date == undefined || this.projInfo.start_date == '') return true;
                return false;
            },
        },
        methods: {

            // 取得專案資料
            getProject (to = undefined, from = undefined, next = undefined)
            {
                // console.log('projID');
                // console.log(this.projID + ' ?' + Math.random());
                let _projID = (next ? to.params.projectID : this.projID)
                // console.log(_projID);

                if (_projID != undefined)
                {
                    this.$store.dispatch('project/getProjectDetail', _projID)
                        .then(res => {
                            if (this.project_detail.editable || this.user_admin) {

                                if (next) next();
                            }
                            else {
                                this.$router.push({
                                    name: 'Page403'
                                }) // 導向 403
                            }


                        })
                        .catch(err => {})
                }
            },


        },
    }

</script>

<style lang="scss" scoped>


</style>
